import AutoloadViews from "@galaxy/modules/Core/resources/js/AutoloadViews";
import vueCustomElement from 'vue-custom-element';
import Vue from 'vue';

// Load all js files
AutoloadViews.load('shop::', require.context('./admin', true, /.(js|vue)$/));

// Init custom vue Components
Vue.use(vueCustomElement);

// Add custom elements
Vue.customElement('shop--admin-categoryselector', require('./admin/CategorySelector.vue').default);
